<template>
  <div id="app" style="height:100%;">
    <router-view v-if="isRouterAlive" ></router-view>
  </div>
</template>
<script>
    export default {
        name: 'App',
        provide(){
            return{
                reload:this.reload,
                isLogin:this.isLogin,
            }
        },
        data(){
            return{
                isRouterAlive:true,
            }
        },
        created() {
            //在页面加载时读取localStorage里的状态信息
            if (localStorage.getItem("store")) {
                this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(localStorage.getItem("store"))))
            }
            //在页面刷新时将vuex里的信息保存到localStorage里
            window.addEventListener("beforeunload",()=>{ 
                localStorage.setItem("store",JSON.stringify(this.$store.state))
            })
        },
        methods:{
            reload(){
                this.isRouterAlive = false
                this.$nextTick(function(){
                    this.isRouterAlive = true
                })
            },
            isLogin(){
                if(this.$store.getters.access_token){
                    return true
                }
                return false
            },
        }
    }
</script>
<style>
@import "./assets/css/font.css";
</style>



// WEBPACK FOOTER //
// src/App.vue